<template>
  <div class="rp-header-parent">
    <div class="main-title">
      <span class="text-primary ml-xs" :title="title">{{ title }}</span>
    </div>
    <div class="rp-types" v-if="ledgerType != 'summary'">
      <span class="summary-title ml-sm" @click="backButtonFunction('account')"
        ><a>{{ summaryTitle }} </a> >
      </span>
      <span
        class="account-title ml-sm"
        @click="ledgerType == 'details' ? backButtonFunction('details') : null"
      >
        <a v-if="ledgerType == 'details'">Account: {{ accountTitle }}</a>
        <span v-if="ledgerType != 'details'">Account: {{ accountTitle }}</span>
        <span v-if="ledgerType == 'details'"> > </span>
      </span>
      <span class="details-title ml-sm" v-if="ledgerType == 'details'"
        >Type : {{ detailsTitle }}
      </span>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-console */
export default {
  props: {
    baseView: Object,
    summaryTitle: {
      type: String,
      default: undefined,
    },
    accountTitle: {
      type: String,
      default: undefined,
    },
    detailsTitle: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: "",
    },
    ledgerType: {
      type: String,
      default: undefined,
    },
    backButtonFunction: {
      type: Function,
      default: function () {
        return null;
      },
    },
  },
  data() {
    return {};
  },
  // created() {
  //   console.log("ledgerType ", this.ledgerType);
  // },
  // updated() {
  //   console.log("ledgerType ", this.ledgerType);
  // },
};
</script>

<style lang="scss">
.rp-header-parent {
  text-align: left;
  .rp-types {
    margin-top: 5px;
    .summary-title,
    .account-title,
    .details-title {
      margin-left: 0;
    }

    .summary-title {
      text-transform: capitalize;
      a {
        cursor: pointer;
      }
    }

    .account-title {
      a {
        cursor: pointer;
      }
    }
  }
}
</style>